//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Number from "@/components/AnimateNumber/index.vue";
import InteractivePanel from "@/components/interactive_panel";
import Award3 from "@/components/award3";
import { conversion } from "@/tool";
import * as apis from "@/api";
export default {
  data() {
    return {
      riskList: [
        {
          name: "L",
          value: "l",
          min: "40",
          max: "100",
          activeBg: "rgb(56, 199, 57)",
          riskSchedule: 12.5,
        },
        {
          name: "M",
          value: "m",
          min: "31",
          max: "40",
          activeBg: "rgb(247, 188, 59)",
          riskSchedule: 37.5,
        },
        {
          name: "H",
          value: "h",
          min: "11",
          max: "30",
          activeBg: "rgb(251, 126, 61)",
          riskSchedule: 61.5,
        },
        {
          name: "I",
          value: "i",
          min: "0",
          max: "10",
          activeBg: "rgb(255, 64, 64)",
          riskSchedule: 87.5,
        },
      ],
      currentRiskSchedule: 0,
      currentRisk: "",
      is_case_item_modal_show: false,
      case_info: {},
      case_awards: [],
    };
  },
  props: {
    caseItem: {
      type: Object,
      default: () => ({}),
    },
    background: {
      type: String,
      default: "",
    },
    showAbLeft: {
      type: Boolean,
      default: false,
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    showfubencishu: {
      type: String,
      default: "",
    },
    showCreatorName: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "c-number": Number,
    "c-interactive-panel": InteractivePanel,
    "c-award": Award3,
  },
  filters: {
    conversion,
  },
  computed: {
    displayPrice() {
      if (this.isHappyCoin && this.caseItem.happyCoinPrice) {
        return this.caseItem.happyCoinPrice;
      }
      return this.caseItem.price;
    },
    isUsingHappyCoin() {
      return this.isHappyCoin && this.caseItem.happyCoinPrice;
    },
  },
  async mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.onInitData();
        this.$forceUpdate();
      });
    }, 100);
  },
  updated(){
    setTimeout(() => {
      this.$nextTick(() => {
        this.onInitData();
      });
    }, 100);
  },
  methods: {
    onInitData() {
      // console.log("this.caseItem==", this.caseItem.caseName);
      this.currentRisk = this.riskList[this.caseItem.riskLevel].value;
      // console.log(
      //   "this.currentRisk==",
      //   this.currentRisk,
      //   this.caseItem.riskLevel
      // );
      this.currentRiskSchedule =
        this.riskList[this.caseItem.riskLevel].riskSchedule;
      this.case_info = this.caseItem;
    },
    async onShowCaseDetail() {
      await this.get_case_info();
      this.is_case_item_modal_show = true;
    },
    onShowCaseLeft() {
      this.$emit("onShowCaseLeft");
    },
    /** 获取箱子信息 */
    async get_case_info() {
      let case_info_response = await apis.api_CaseDetail(this.caseItem.caseId);
      if (case_info_response.data.code !== 0) {
        return;
      }
      const respone = case_info_response.data.data;
      this.case_info = respone.caseInfo;
      this.case_awards = respone.items;
      var totalRate = this.case_awards
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);
      this.case_awards.forEach((item, index) => {
        item.viewRate =
          Math.ceil((item.viewRate / totalRate) * 10000000) / 100000;
      });
    },
    async get_currentRiskSchedule() {
      let highRiskList = [],
        LowRiskList = [];
      await this.case_awards.forEach((items) => {
        if (items.price >= this.caseItem.price) {
          highRiskList.push(items.viewRate);
        } else {
          LowRiskList.push(items.viewRate);
        }
      });
      const highRiskReduce = parseInt(
        highRiskList.reduce((accumulator, item) => {
          return accumulator + item;
        }, 0)
      );
      const LowRiskListReduce = parseInt(
        LowRiskList.reduce((accumulator, item) => {
          return accumulator + item;
        }, 0)
      );
      if (highRiskReduce > 40 && highRiskReduce <= 100) {
        this.currentRisk = "l";
        this.currentRiskSchedule = 12.5;
      } else if (highRiskReduce > 30 && highRiskReduce <= 40) {
        this.currentRisk = "m";
        this.currentRiskSchedule = 37.5;
      } else if (highRiskReduce > 10 && highRiskReduce <= 30) {
        this.currentRisk = "h";
        this.currentRiskSchedule = 61.5;
      } else if (highRiskReduce >= 0 && highRiskReduce <= 10) {
        this.currentRisk = "i";
        this.currentRiskSchedule = 87.5;
      }
    },
    onCaseDetail() {
      this.$emit("onCaseDetailHadle", this.caseItem.caseId);
    },
  },
};
